module.exports = __webpack_public_path__ + "img/ico_plus.ef290538.svg";